{
  "DATA_ASSISTANT": {
    "TITLE": "Asistent de date",
    "NEW_CONVERSATION": "+ Nou",
    "LOADING": "Se încarcă...",
    "LOADING_MESSAGES": "Se încarcă mesajele...",
    "THINKING": "Se gândește...",
    "UNTITLED": "Conversație fără titlu",
    "NO_CONVERSATIONS": "Nicio conversație încă. Faceți clic pe „+ Nou” pentru a începe.",
    "EMPTY_STATE": "Selectați o conversație sau creați una nouă pentru a începe.",
    "SEND": "Trimite",
    "PLACEHOLDER": "Ce pot afla pentru dumneavoastră?",
    "SHOW_SQL": "Afișează SQL",
    "NO_ROWS": "Niciun rând returnat.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Șterge conversația",
    "DELETE_CONFIRM_DESCRIPTION": "Sigur doriți să ștergeți această conversație? Această acțiune nu poate fi anulată.",
    "DELETE_CONFIRM_YES": "Șterge",
    "CHAT": "Chat",
    "REPORTS": "Rapoarte",
    "SAVE_TO_REPORT": "Salvează în raport",
    "NEW_REPORT": "Raport nou",
    "REPORT_NAME": "Nume raport",
    "NO_REPORTS": "Niciun raport salvat încă",
    "REPORTS_EMPTY_STATE": "Selectați un raport sau creați unul nou.",
    "REPORT_SAVED": "Salvat în raport",
    "DELETE_REPORT_CONFIRM": "Șterge raportul",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Sigur doriți să ștergeți acest raport? Toate elementele salvate vor fi eliminate.",
    "DELETE_ITEM_CONFIRM": "Elimină element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Sigur doriți să eliminați acest element din raport?",
    "EXPORT_CSV": "Exportă CSV",
    "REFRESH": "Reîmprospătează",
    "QUERY_RUNNING": "Se execută interogarea...",
    "QUERY_FAILED": "Interogarea a eșuat",
    "AUTO_REFRESH": "Reîmprospătare automată",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 de secunde",
    "AUTO_REFRESH_1M": "1 minut",
    "AUTO_REFRESH_5M": "5 minute",
    "AUTO_REFRESH_10M": "10 minute",
    "EDIT_MESSAGE": "Editează mesaj",
    "RENAME_REPORT": "Redenumește raportul",
    "RENAME_ITEM": "Redenumește elementul",
    "MOVE_UP": "Mută în sus",
    "MOVE_DOWN": "Mută în jos",
    "COLLABORATORS": {
      "BUTTON": "Colaboratori",
      "TITLE": "Colaboratori raport",
      "DESCRIPTION": "Alegeți ce agenți și echipe pot vedea acest raport.",
      "AGENTS": "Agenți",
      "TEAMS": "Echipe",
      "SELECT_AGENTS": "Selectați agenții",
      "SELECT_TEAMS": "Selectați echipele",
      "SAVE": "Salvează",
      "SAVED": "Colaboratori actualizați",
      "SAVE_FAILED": "Actualizarea colaboratorilor a eșuat"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Rapoarte"
}
